'use client';

/** Плавно прокручивает страницу к элементу с учетом высоты хедера */
export const utilScrollToElement = (element: HTMLElement | null) => {
  if (!element) return;

  const headerHeight =
    parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue(
        '--head-fixed-height'
      )
    ) || 64;

  const elementPosition = element.getBoundingClientRect().top;
  const targetPosition = elementPosition + window.pageYOffset - headerHeight;

  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
};
